// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
// Shared millisecond time constants for timers, React Query cache durations,
// and any other place where a duration is needed. Domain-specific durations
// (animation timings, throughput estimates, report loader UX tuning) should
// stay local — this file is for unit values, not decisions.

const ONE_SECOND_MS = 1_000;
export const THIRTY_SECONDS_MS = 30 * ONE_SECOND_MS;
export const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
export const TWO_MINUTES_MS = 2 * ONE_MINUTE_MS;
export const FIVE_MINUTES_MS = 5 * ONE_MINUTE_MS;
export const TEN_MINUTES_MS = 10 * ONE_MINUTE_MS;
export const FIFTEEN_MINUTES_MS = 15 * ONE_MINUTE_MS;
export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
export const ONE_DAY_MS = 24 * ONE_HOUR_MS;
